export const getCountriesWithoutZipCode = (countriesObj) =>
  countriesObj?.data?.countries
    ? countriesObj.data.countries
        .filter((obj) => obj.postcode !== true)
        .map((obj) => obj.countryCode)
    : [];
